import * as React from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography
} from "@mui/material";
import { Link } from 'react-router-dom';

export const ReservedTable = (props) => {
    const { record, ...rest } = props;

    return (
        record.reserved && record.reserved.length > 0 ?
        <TableContainer sx={{border: "1px solid #ebebeb", borderRadius: "8px", boxShadow: "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)"}}>
            <Table size="small">
                <TableHead>
                <TableRow>
                    <TableCell>
                    ID
                    </TableCell>
                    <TableCell>
                    Order Split Increment
                    </TableCell>
                    <TableCell>
                    Quantity
                    </TableCell>
                </TableRow>
                </TableHead>

                <TableBody>
                { record.reserved.map((orderItem, orderItemIndex) => {
                    return (
                        <>
                        <TableRow key={`row_${orderItemIndex}`} >
                            <TableCell>
                                {orderItem.id}
                            </TableCell>
                            <TableCell>
                                <Link 
                                    to={`/admin/orders/${orderItem.order_id}/show`}
                                    style={{color: "#1976d2", textDecoration: "none", fontWeight: 600}}
                                    target="_blank"
                                >
                                    {orderItem.order_increment_id}
                                </Link>
                            </TableCell>
                            <TableCell>
                                {orderItem.quantity}
                            </TableCell>
                        </TableRow>
                        </>
                    )   
                })}
                </TableBody>
            </Table>
        </TableContainer>
        : 
        <Typography             
            component="span" 
            sx={{ 
                fontSize: "14px", 
                fontWeight: 600,
                color: "#65748B",
            }}
        >
            No Reserved Items
        </Typography>
    );
}
